import $ from "jquery";
window.$ = $;
window.jQuery = $;

import Rails from '@rails/ujs'
// garante que será chamado somente 1 vez
if (!window._rails_ujs_started) {
  Rails.start();
  window._rails_ujs_started = true;
}

import "@hotwired/turbo-rails"
// import { Turbo } from "@hotwired/turbo-rails"
// Turbo.start()

import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

import 'channels'

require("jquery")
require("easy-autocomplete")
require("bootstrap-maxlength")

require("./custom/bootstrap.min")
require("./custom/util")

require("./site/sticky_sidebar.min")
require("./site/common_scripts")
require("./site/common_func")
require("./custom/base")

var Inputmask = require("inputmask");



const images = require.context('../../assets/images', true, /\.(gif|jpg|png|svg|ico)$/i)
const imagePath = (name) => images(name, true)